<template>
  <v-container fill-height container--fluid >
      <v-row>
        <v-col cols="12">
            <v-breadcrumbs
            :items="breadCrumbsItems"
              divider=">"
              ></v-breadcrumbs>
        </v-col>
      </v-row>
      <summary-of-account :filterUsers="filterUser" />
  </v-container>
</template>
<script>
import userAPIs from '../User/userAPIs';
import SummaryOfAccount from '../DashboardComponents/summaryOfAccount'
import config from '@/config';

export default {
  name: 'CO_Spend_Revenue',
  components: {
    SummaryOfAccount
  },
  data() {
    return {
      breadCrumbsItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/co/dashboard'
        },
        {
          text: 'Spend Revenue',
          disabled: true,
          href: ''
        }
      ],
      filterUser: []
    }
  },
  computed: {
  },
  async mounted() {
    let response
    // Get all AM users
    response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (response) {
      this.filterUser = response.users.map(user => {
        user.name = `${user.firstName} ${user.lastName}`
        return user
      })
      this.filterUser.unshift({id: '', name: 'All Team'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// spendRevenue.vue?1032cbfe